<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5541_39150)">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.49987 20.525C8.30473 20.9897 9.30718 20.8266 9.93051 20.1903C10.1238 19.9931 10.0381 19.681 9.79891 19.543L7.20083 18.043C6.96169 17.9049 6.64862 17.9867 6.5744 18.2527C6.33501 19.1107 6.69501 20.0603 7.49987 20.525Z"
            fill="#8F9BA0" />
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M20.3122 12.3339L16.5622 18.829L17.2407 21.361C17.275 21.4891 17.257 21.6256 17.1907 21.7405L17.0443 21.9941C16.9062 22.2333 16.6004 22.3152 16.3613 22.1771L1.63884 13.6771C1.39969 13.539 1.31775 13.2333 1.45582 12.9941L1.60227 12.7405C1.66857 12.6256 1.77778 12.5418 1.90587 12.5075L4.43787 11.829L8.18786 5.33387C9.72786 2.66651 13.2942 1.76949 16.111 2.61059L16.451 2.02169C16.866 1.30289 17.7812 1.05766 18.5 1.47266C19.2188 1.88766 19.4641 2.80289 19.0491 3.52169L18.7091 4.11059C20.8546 6.13449 21.8472 9.67517 20.3122 12.3339ZM16.5 4.93676C14.1086 3.55605 11.0506 4.37542 9.66991 6.76688L5.91991 13.2621C5.78184 13.5012 5.86378 13.807 6.10292 13.9451L13.8972 18.4451C14.1363 18.5832 14.4421 18.5012 14.5802 18.2621L18.3302 11.7669C19.7109 9.37542 18.8915 6.31747 16.5 4.93676Z"
            fill="#8F9BA0" />
    </g>
    <defs>
      <clipPath id="clip0_5541_39150">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
